import React from 'react'
import '../../App.css'
import './Home.css'
import HeroSection from '../HeroSection'

export const Home = () => {
  return (
    <>
      <HeroSection />
    </>
  )
}
